import React from 'react';

import Activity from './activity';
import type { Parent, ParentOption } from 'bundles/crm/types';
import type { Activity as ActivityType } from 'bundles/apex/activities/types';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import EmptyState from 'shared/empty_state';

interface ActivityListProps {
  activities: ActivityType[];
  currentParent?: Parent | Parent[];
  forUserId?: number;
  hasFilters?: boolean;
  isBackofficeAdmin?: boolean;
  showParents?: boolean | 'path';
  tagText?: string;
  options?: {
    parents?: ParentOption[];
  }
  onDelete: (activity: ActivityType) => void;
  onSave: (activity: ActivityType) => void;
}

export default function ActivityList({ activities, showParents, ...props }: ActivityListProps) {
  const activityProps = { showParents, ...props };

  if (activities.length === 0) {
    return (
      <EmptyState
        header="No Activities to Display"
        icon={faCircleExclamation}
      />
    );
  }

  return (
    <div className="d-flex flex-column">
      {activities.map(activity => (
        <Activity {...activityProps} activity={activity} key={activity.id} />
      ))}
    </div>
  );
}
